import { TYPES } from "./income_detail.type";


const initState = {
  all: null,
};

const incomeDetailReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_INCOME_SUCCESS:
      return {
        ...state,
        all: payload,
      };

    default:
      return state;
  }
};

export default incomeDetailReducer;